import React from 'react'
import { Link } from 'gatsby'
import { Layout, Header, Showcase, SectionTitle } from '../../../../components'

import data from './data.json'

export default props => {
  const code = null

  return (
    <>
      <Header
        title={data.title}
        site={data.site}
        state="design"
        slug={data.slug + '/design/'}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <div class="intro">
          <p>
            Badges are small labels that appear in proximity to larger UI
            elements and relay a{' '}
            <Link
              className="link"
              to={'/' + data.site + '/guidelines/status/design'}
            >
              status
            </Link>
            , property or other metadata related to the larger object. Badges
            are not interactive and should only convey relevant information.
          </p>
        </div>
        <SectionTitle>Variants</SectionTitle>
        <Showcase
          site={data.site}
          title="Inactive Badge"
          text="Used to indicate a neutral property status or metadata that requires less attention"
          code={code}
        >
          <div class="c-badge--inactive">Inactive</div>
        </Showcase>

        <Showcase
          site={data.site}
          title="Positive Badge"
          text='Used to indicate a positive property or status, such as "delivered" or "active"'
          code={code}
        >
          <div class="c-badge--positive">Positive</div>
        </Showcase>

        <Showcase
          site={data.site}
          title="Processing Badge"
          text='Used to indicate an in-progress property or status, such as "in review" or "pending"'
          code={code}
        >
          <div class="c-badge--processing">Processing</div>
        </Showcase>

        <Showcase
          site={data.site}
          title="Negative Badge"
          text='Used to indicate a negative property or status, such as "failed" or "rejected"'
          code={code}
        >
          <div class="c-badge--negative">Negative</div>
        </Showcase>
        <SectionTitle>Legacy Badges</SectionTitle>
        <Showcase
          site={data.site}
          title="Inactive Badge"
          text="Used to indicate a neutral property status or metadata that requires less attention"
          code={code}
        >
          <div class="c-badge-legacy--inactive">Inactive</div>
        </Showcase>

        <Showcase
          site={data.site}
          title="Positive Badge"
          text='Used to indicate a positive property or status, such as "delivered" or "active"'
          code={code}
        >
          <div class="c-badge-legacy--positive">Positive</div>
        </Showcase>

        <Showcase
          site={data.site}
          title="Processing Badge"
          text='Used to indicate an in-progress property or status, such as "in review" or "pending"'
          code={code}
        >
          <div class="c-badge-legacy--processing">Processing</div>
        </Showcase>

        <Showcase
          site={data.site}
          title="Negative Badge"
          text='Used to indicate a negative property or status, such as "failed" or "rejected"'
          code={code}
        >
          <div class="c-badge-legacy--negative">Negative</div>
        </Showcase>

        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Because badges always give information about another interface
          element, they cannot stand alone. Place them near the object in the
          layout they are describing.
        </p>
        <hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Per the{' '}
          <Link
            className="link"
            to={'/' + data.site + '/guidelines/status/design'}
          >
            status
          </Link>{' '}
          writing guidelines, copy should be kept concise. In badges, it's best
          to display on or two short words. Do not use full sentences.
        </p>
      </Layout>
    </>
  )
}
